// Guests action types

const guestsModalActionTypes = {
  SET_GUESTS_ADULTS_COUNT: 'SET_GUESTS_ADULTS_COUNT',
  SET_GUESTS_KIDS_COUNT: 'SET_GUESTS_KIDS_COUNT',
  SET_GUESTS_KIDS_AGES: 'SET_GUESTS_KIDS_AGES'
};

export default guestsModalActionTypes;
